export default __webpack_public_path__ + "static/media/Mombacho.5e788614.jpg";